export const SESSIONS = ["Morning", "Afternoon", "Evening", "Night"] as const;
export const AGE_CATEGORIES = [
  "<28 days neonate",
  "<1 yr",
  "1-4 yrs",
  "5-9 yrs",
  "10-17 yrs",
  "18-59 yrs",
  "60-79 yrs",
  "≥80 yrs",
] as const;
export const ASA_GRADES = ["1", "2", "3", "4", "5", "Donor"] as const;
export const URGENCIES = ["Elective", "Expedited", "Urgent", "Immediate"] as const;
export const ROLES = ["Primary", "Co-anaesthetist", "Supervised", "Supervisor"] as const;
export const SUPERVISION_LEVELS = ["1", "2a", "2b", "3", "4"] as const;
export const SUPERVISOR_GRADES = ["Consultant", "SAS", "Senior Trainee", "Other"] as const;
export const DAY_CASE_OPTIONS = ["Yes", "No"] as const;
export const ANAESTHETIC_TYPES = [
  "None",
  "GA-TIVA",
  "GA-Volatile",
  "GA-Combined",
  "Sedation",
  "Regional & Sedation",
  "Regional only",
  "LA only",
  "Monitored care",
] as const;
export const EQUIPMENT_OPTIONS = [
  "Standard",
  "Videolaryngoscope",
  "Fibreoptic scope",
  "Rigid fibrescope",
] as const;
export const BREATHING_OPTIONS = ["Spontaneous", "IPPV", "Jet", "High-flow O2"] as const;
export const AWAKE_OPTIONS = ["Awake", "Asleep"] as const;
export const FUNDING_OPTIONS = ["NHS", "Private - Insured", "Private - Self-funding"] as const;
export const POSITIONS = [
  "None",
  "Supine",
  "Lateral",
  "Prone",
  "Lithotomy",
  "Beach chair",
  "Sitting",
  "Trendelenburg",
  "Lloyd-Davies",
] as const;
export const POST_OP_DESTINATIONS = [
  "None",
  "Day surgery",
  "Ward",
  "HDU",
  "ICU",
  "PICU",
  "Neonatal ICU",
  "Neuro ICU",
  "Cardiothoracic ICU",
  "Direct home",
] as const;
export const TEACHING_OPTIONS = [
  "None",
  "Medical student",
  "Novice",
  "Trainee",
  "Consultant / Career grade",
  "Allied health professional",
] as const;
export const SPECIALTIES = [
  "Cardiac",
  "Bariatric",
  "Breast",
  "Dental",
  "ENT",
  "General",
  "Gynaecology",
  "Hepatobiliary",
  "Transfer",
  "Maxillo-facial",
  "Neonates",
  "Neurosurgery",
  "Other",
  "Obstetrics",
  "Ophthalmics",
  "Orthopaedics",
  "Paediatrics",
  "Plastics/burns",
  "Radiology",
  "Resuscitation",
  "Thoracic",
  "Trauma",
  "Urology",
  "Vascular",
  "Chronic Pain",
] as const;
export const AIRWAY_OPTIONS = [
  "None",
  "Patient's own airway",
  "Facemask",
  "LMA",
  "i-gel",
  "SGA",
  "ETT",
  "VL ETT",
  "Direct ETT",
  "VAFI",
  "Fibreoptic awake",
  "Fibreoptic asleep",
  "DLT",
  "Bronchial blocker",
  "Jet ventilation",
  "HFNO",
] as const;
export const REGIONAL_OPTIONS = [
  "Spinal",
  "Epidural",
  "CSE",
  "Caudal",
  "TAP",
  "Ilioinguinal",
  "QLB",
  "Erector spinae",
  "PVB",
  "PECS I",
  "PECS II",
  "Serratus anterior",
  "Femoral",
  "Adductor canal",
  "FIB",
  "Popliteal sciatic",
  "Ankle block",
  "Sciatic (other)",
  "Axillary",
  "Infraclavicular",
  "Supraclavicular",
  "Interscalene",
  "Penile",
  "Pudendal",
  "Peribulbar",
  "Rectus sheath",
  "Wound infiltration",
  "Other",
] as const;
export const ACCESS_OPTIONS = [
  "Peripheral IV",
  "Arterial line",
  "CVC (IJV)",
  "CVC (subclavian)",
  "CVC (femoral)",
  "PICC",
  "Intraosseous",
  "Chest drain",
  "TOE",
  "Bronchoscopy",
  "Awake intubation",
  "Perc tracheostomy",
  "Surg tracheostomy",
  "DLT placement",
  "RSI",
  "TIVA/TCI",
  "Epidural blood patch",
  "Epidural top up",
  "DC cardioversion",
  "Lumbar drain",
  "Gas induction",
  "Prone positioning",
] as const;
export const COMPLICATION_OPTIONS = [
  "None",
  "Difficult airway (anticipated)",
  "Difficult airway (unanticipated)",
  "Failed intubation",
  "Laryngospasm",
  "Bronchospasm",
  "Desaturation",
  "CVS instability",
  "Cardiac arrest",
  "Anaphylaxis",
  "Massive haemorrhage",
  "High/total spinal",
  "Failed regional",
  "PDPH",
  "Awareness",
  "MH trigger",
  "Post-op N&V",
  "Post-op resp",
  "Nerve injury",
  "Other",
] as const;

export const CATALOGUE_BY_FIELD = {
  session: SESSIONS,
  age: AGE_CATEGORIES,
  asa: ASA_GRADES,
  spec: SPECIALTIES,
  urg: URGENCIES,
  role: ROLES,
  maint: ANAESTHETIC_TYPES,
  anaesthetic_equipment: EQUIPMENT_OPTIONS,
  breathing: BREATHING_OPTIONS,
  airway: AIRWAY_OPTIONS,
  airway_awake_status: AWAKE_OPTIONS,
  regional: REGIONAL_OPTIONS,
  access_new: ACCESS_OPTIONS,
  position: POSITIONS,
  dayCase: DAY_CASE_OPTIONS,
  postop: POST_OP_DESTINATIONS,
  complications: COMPLICATION_OPTIONS,
  sup: SUPERVISION_LEVELS,
  supGrade: SUPERVISOR_GRADES,
  teaching: TEACHING_OPTIONS,
  funding: FUNDING_OPTIONS,
} as const;

